/**
 * Search rows are plain text. A stored chat line can still carry
 * markdown ("1. **Electrical failure"). The snippet shows the words.
 */
export function plainSearchSnippet(content) {
  let text = String(content || '');
  text = text.replace(/```[\s\S]*?```/g, ' ');
  text = text.replace(/`([^`]*)`/g, '$1');
  text = text.replace(/!\[[^\]]*]\([^)]*\)/g, ' ');
  text = text.replace(/\[([^\]]+)]\([^)]*\)/g, '$1');
  text = text.replace(/^#{1,6}\s+/gm, '');
  text = text.replace(/^\s*(?:[-*+]|\d+[.)])\s+/gm, '');
  text = text.replace(/(\*\*|__)([\s\S]*?)\1/g, '$2');
  text = text.replace(/(\*|_)([^*\n_]+)\1/g, '$2');
  text = text.replace(/[*_]+/g, '');
  return text.replace(/\s+/g, ' ').trim();
}
